import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/api";
import React from "react";
import { BellAlertsProvider } from "../contexts/app/bellAlertsContext";

export default function Home() {
  const { isLogged } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isLogged) {
      navigate("/login");
    }
  }, [isLogged, navigate]);

  return (
    <BellAlertsProvider>
      <Outlet />
    </BellAlertsProvider>
  );
}
